<template>
  <div class="orderInfo">
    <div class="orderItem orderId">
      购卡人联系电话：{{buypersontele}}
    </div>
    <div class="orderItem">
      <div class="orderItem_title">收货信息：</div>
      <div class="orderItem_con">
        <div class="orderItem_con_title">收货人姓名：</div>
        <div class="orderItem_con_con">{{consigneename}}</div>
      </div>
      <div class="orderItem_con">
        <div class="orderItem_con_title">收货人电话：</div>
        <div class="orderItem_con_con">{{consigneetele}}</div>
      </div>
      <div class="orderItem_con">
        <div class="orderItem_con_title">收货地址：</div>
        <div class="orderItem_con_con">{{address}}</div>
      </div>
      <div class="orderItem_con">
        <div class="orderItem_con_title">快递公司：</div>
        <div class="orderItem_con_con">{{expresscompany}}</div>
      </div>
      <div class="orderItem_con">
        <div class="orderItem_con_title">快递单号：</div>
        <div class="orderItem_con_con">{{expressNumber}}</div>
      </div>
      <div class="orderItem_con">
        <div class="orderItem_con_title">物流信息：</div>
        <div class="orderItem_con_con" @click="lookExpress(sdk_order_id)" :style="{color:logisticsInformationColor}">{{logisticsInformation}}</div>
      </div>
    </div>

    <div class="orderItem">
      <div class="orderItem_title">购卡实名信息：</div>
      <div class="orderItem_con">
        <div class="orderItem_con_title">购卡实名人：</div>
        <div class="orderItem_con_con">{{buypersonname}}</div>
      </div>
      <div class="orderItem_con">
        <div class="orderItem_con_title">实名证件号：</div>
        <div class="orderItem_con_con">{{buypersonidcard}}</div>
      </div>
    </div>

    <div class="orderItem">
      <div class="orderItem_title">订单信息：</div>
      <div class="orderinfo">
        <div class="orderInfo_left">
          <div class="orderItem_con">
            <div class="orderItem_con_title">支付时间：</div>
            <div class="orderItem_con_con">{{paytime}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">订单号：</div>
            <div class="orderItem_con_con">{{orderid}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">订单状态：</div>
            <div class="orderItem_con_con">{{orderstatu}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">所选号码：</div>
            <div class="orderItem_con_con">{{buynumber}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">ICCID：</div>
            <div class="orderItem_con_con">{{numICCID}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">号码等级：</div>
            <div class="orderItem_con_con">{{numlevel}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">归属地：</div>
            <div class="orderItem_con_con">{{numcity}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">所选套餐：</div>
            <div class="orderItem_con_con">{{numpackage}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">权益包：</div>
            <div class="orderItem_con_con">
              <div v-for="(item,index) in numequity" :key="index">{{item.title}}</div>
            </div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">增值业务：</div>
            <div class="orderItem_con_con">
              <div v-for="(item,index) in valueaddedservice" :key="index">{{item.title}}</div>
            </div>
          </div>
        </div>
        <div class="orderInfo_right">
          <div class="orderItem_con">
            <div class="orderItem_con_title">首月服务费：</div>
            <div class="orderItem_con_con">￥{{(nummoney/100).toFixed(2)}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">套餐预存费：</div>
            <div class="orderItem_con_con">￥{{(numprestorage/100).toFixed(2)}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">首月服务费优惠：</div>
            <div class="orderItem_con_con">-￥{{((nummoney - nummoneysale)/100).toFixed(2)}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">套餐预存费优惠：</div>
            <div class="orderItem_con_con">-￥{{((numprestorage - numprestoragesale)/100).toFixed(2)}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">运费：</div>
            <div class="orderItem_con_con">￥{{(freight/100).toFixed(2)}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">订单总计：</div>
            <div class="orderItem_con_con">￥{{(totalmoney/100).toFixed(2)}}</div>
          </div>
          <div class="orderItem_con">
            <div class="orderItem_con_title">实付金额：</div>
            <div class="orderItem_con_con">￥{{(paymoney/100).toFixed(2)}}</div>
          </div>
        </div>
      </div>
      
    </div>

    <el-dialog
      title="物流详情"
      :visible.sync="dialogVisible"
      width="700px"
      top="100px"
      :before-close="handleClose">
      <express :sdk_order_id="sdk_order_id"></express>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">知道啦</el-button>
      </span>
    </el-dialog>

    <div class="orderBtn">
      <div class="erweima" v-if="orderstatus == 4 || orderstatus == 5">
        <img src="../../assets/ywLogo.png" alt="">
        <div>微信扫码关注“远微商城”，一键激活号卡</div>
      </div>
      <div class="btnbox">
        <div class="returnBtn cursor" @click="goorderlist">返回</div>
        <div class="refundBtn cursor" @click="refundFunc">退款</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import express from '../../components/express/express';
export default {
  name: "orderInfo",
  components: {
    express
  },
  props: {
  },
  data(){
    return {
      token : window.localStorage.getItem('token'),
      loading : '',
      sdk_order_id : '',
      buypersontele : '暂无', //购卡人联系电话：
      consigneename : '暂无', //收货人姓名：
      consigneetele : '暂无', //收货人电话：
      address : '暂无', //收货地址：
      expresscompany : '暂无',  //快递公司：
      expressNumber : '暂无', //快递单号：
      logisticsInformation : '暂无',  //物流信息： 
      logisticsInformationColor : '#303133',
      buypersonname : '暂无', //购卡实名人：
      buypersonidcard : '暂无', //实名证件号：
      paytime : '暂无', //支付时间：
      orderid : '暂无', //订单号：
      orderstatu : '暂无', //订单状态：
      orderstatus : 0,  //订单状态：已发货、已收货显示二维码
      buynumber : '暂无', //所选号码：
      numICCID : '暂无', //ICCID：
      numlevel : '暂无', //号码等级：
      numcity : '暂无', //归属地：
      numpackage : '暂无', //所选套餐：
      numequity : [], //权益包：
      valueaddedservice : [], //增值业务：
      nummoney : 0, //首月服务费：
      numprestorage : 0, //套餐预存费：
      nummoneysale : 0, //首月服务费优惠：
      numprestoragesale : 0, //套餐预存费优惠：
      freight : 0, //运费：
      totalmoney : 0, //订单总计：
      paymoney : 0, //实付金额：
      orderStatuList : ['进行中','已关闭','已支付','已制卡','已发货','已收货','已退货'],
      dialogVisible : false,
    }
  },
  methods: {
    Loading : function(text){
      this.loading = Loading.service({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    alertMsg : function(msg){
      this.$message({
        message: msg,
        type: 'error',
        offset: '300'
      });
    },
    //物流查询
    lookExpress : function(sdk_order_id){
      this.sdk_order_id = sdk_order_id;
      this.dialogVisible = true;
    },
    handleClose(done) {
      done();
    },
    goorderlist : function(){
      this.$router.go(-1);
    },
    refundFunc : function(){
      this.$alert('请您联系人工客服进行退款，客服电话：4000130130', '温馨提示', {
        showConfirmButton: false,
        center: true,
        callback: action => {}
      });
    },
    getorderInfo : function(){
      this.sdk_order_id = this.$route.params.orderId;
      var params = {
        "token": this.token,
        "sdk_order_id": this.sdk_order_id
      }
      var that = this;
      this.$http.post('/getOrderDetail',params,{emulateJSON: true})
        .then(function(res) { 
          that.loading.close();
          var data = res.data;
          if(data.code == "200"){
            that.buypersontele = data.data.orderInfo.linkPhone; //购卡人联系电话：
            that.consigneename = data.data.postInfo.postName; //收货人姓名：
            that.consigneetele = data.data.postInfo.postPhone; //收货人电话：
            that.address = data.data.postInfo.postAddress; //收货地址：
            that.expresscompany = data.data.postInfo.postCompany == '' ? "暂无" : data.data.postInfo.postCompany;  //快递公司：
            that.expressNumber = data.data.postInfo.postOrder == '' ? "暂无" : data.data.postInfo.postOrder; //快递单号：
            that.logisticsInformation = data.data.postInfo.postOrder == '' ? "暂无" : "查看物流";  //物流信息： 
            that.logisticsInformationColor = data.data.postInfo.postOrder == '' ? "#303133" : "#1989FA";
            that.buypersonname = data.data.idCardInfo.idName == '' ? "暂无" : data.data.idCardInfo.idName; //购卡实名人：
            that.buypersonidcard = data.data.idCardInfo.idNum == '' ? "暂无" : data.data.idCardInfo.idNum; //实名证件号：
            that.paytime = data.data.orderTime.payTime == '' ? "暂无" : that.timeTrans(data.data.orderTime.payTime); //支付时间：
            that.orderid = that.sdk_order_id; //订单号：
            that.orderstatu = that.orderStatuList[parseInt(data.data.orderInfo.orderStatus)-1]; //订单状态：
            that.orderstatus = parseInt(data.data.orderInfo.orderStatus)-1; //订单状态：已发货、已收货显示二维码
            that.buynumber = data.data.orderInfo.phoneNumber; //所选号码：
            that.numICCID = data.data.orderInfo.iccid == "" ? "暂无" : data.data.orderInfo.iccid; //ICCID：
            that.numlevel = data.data.orderInfo.pretty == 1 ? "靓号" : "普号"; //号码等级：
            that.numcity = data.data.orderInfo.cityName; //归属地：
            that.numpackage = data.data.orderInfo.packageTitle; //所选套餐：
            that.numequity = data.data.orderInfo.quanyiList; //权益包：
            that.valueaddedservice = data.data.orderInfo.optList; //增值业务：
            that.nummoney = parseInt(data.data.orderInfo.cardMoney); //首月服务费：
            that.numprestorage = parseInt(data.data.orderInfo.prestoreMoney); //套餐预存费：
            that.nummoneysale = parseInt(data.data.orderInfo.cardMoneyActual); //首月服务费优惠：
            that.numprestoragesale = parseInt(data.data.orderInfo.prestoreMoneyActual); //套餐预存费优惠：
            that.freight = parseInt(data.data.orderInfo.postCost); //运费：
            that.totalmoney = parseInt(data.data.orderInfo.totalMoney); //订单总计：
            that.paymoney = parseInt(data.data.orderInfo.actualMoney); //实付金额：
          } else {
            that.alertMsg(data.msg);
          }
        })
        .catch(function(err) {
          console.log(err);
          that.loading.close();
          that.alertMsg("订单详情查询失败，请重试");
        });
    },
    timeTrans: function(times) {
      let date = new Date(parseInt(times));
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let h = date.getHours();
      let m = date.getMinutes();
      let s = date.getSeconds();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      return year + "-" + month + "-" + day + " " + h + ":" + m + ":" + s;
    }
  },
  beforeMount: function() {
    this.Loading("Loading...");
  },
  mounted: function() {
    this.getorderInfo();
    this.$emit('gotoOrder','2');
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.orderInfo {
  .cursor {
    cursor: pointer;
  }
  margin-top: 20px;
  background: #ffffff;
  width: 100%;
  padding: 20px 50px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 8px;
  text-align: left;
  .orderItem {
    padding: 20px 0;
    border-bottom: 1px solid #e9e9e9;
    .orderItem_title {
      color: #303133;
      font-weight: 600;
      line-height: 22px;
      font-size: 16px;
      padding-bottom: 15px;
    }
    .orderItem_con {
      display: flex;
      font-size: 14px;
      padding-bottom: 10px;
      .orderItem_con_title {
        color: #909399;
        width: 90px;
      }
      .orderItem_con_con {
        color: #303133;
        div {
          padding-bottom: 10px;
        }
      }
    }
    .orderinfo {
      display: flex;
      justify-content: space-between;
      .orderInfo_left {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }
      .orderInfo_right {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .orderItem_con_title {
          color: #909399;
          width: 120px;
          text-align: right;
        }
        .orderItem_con_con {
          text-align: right;
          color: #5cb87a;
          min-width: 80px;
        }
      }
    }
  }
  .orderId {
    color: #303133;
    font-weight: 600;
    line-height: 22px;
    font-size: 16px;
    padding: 10px 0 30px;
  }
  .orderBtn {
    padding-top: 20px;
    .erweima{
      text-align: center;
      font-size: 16px;
      img{
        width: 290px;
        height: 290px;
      }
    }
    .btnbox{
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        width: 90px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        text-align: center;
        color: #606266;
      }
    }
  }
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
